<template>
  <div class='h100vh-116 h-mml-midlistbox'>
    <div class='h-mml-midinputbox'>
      <div class='h-mml-inputbigbox'>
        <ejs-textbox :placeholder='SearchHolder' v-model='keywords'>
          <span class="icon hero-icon hero-icon-search"></span>
        </ejs-textbox>
      </div>
    </div>
    <div class='h-scroll h100-40'>
      <mo-global-tree :fields='fieldsFiltered'></mo-global-tree>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import MoGlobalTree from '@/components/mmlconfig/midPanel/MoGlobalTree.vue';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import qs from 'qs';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'mid-global-panel',
  components: {
    MoGlobalTree
  },
  mixins: [packageParams],
  data() {
    return {
      SearchHolder: this.$t('MML.searchHolder'),
      keywords: '',
      sortedMoDatas: {},
      moDatas4Tree: {}
    };
  },
  mounted() {
    bus.$on('loadMoTree', (node) => {
      this.changeNode(node);
      this.loadMoTree();
      // this.loadDevMoTree(node);
      bus.$emit('refreshAndLoadTabsGlobal');
    });
  },
  computed: {
    ...mapGetters(['currentNode']),
    fieldsFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return { dataSource: this.moDatas4Tree, id: 'moName', tooltip: this.LOCALE === 'zh'?'zhName':'enName', text: this.LOCALE === 'zh'?'zhName':'enName', child: 'children' };
      }
      const leftMoDatas = this.sortedMoDatas.filter(moData => this.containsKeywords(moData, trimedKeyWords));
      return { dataSource: leftMoDatas, id: 'moName', tooltip: this.LOCALE === 'zh'?'zhName':'enName', text: this.LOCALE === 'zh'?'zhName':'enName', child: 'children' };
    }
  },
  methods: {
    ...mapMutations(['changeNode', 'changeMo', 'changeCommand', 'changeMassModMode', 'changeMassModExecingState']),
    loadMoTree() {
      // const loadMoTreeDispatcher = {
      //   ne: this.loadNeMoTree,
      //   equipment: this.loadDevMoTree
      // };
      // loadMoTreeDispatcher[this.currentNode.nodeType]();
      // TODO 待加緩存 by s18857
      const params = this.packageMoSearchParams(this.currentNode);
      const config = {
        params: params,
        paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
      }
      this.axios.get('/lte/ems/config/mml/searchMoName',config).then((response) => {
        const moDataArr = response.data.resultVal;
        // if (moDataArr.length <= 0) { return; }
        this.sortedMoDatas = moDataArr.sort(this.compare());
        this.moDatas4Tree = this.transfer2TreeData(this.sortedMoDatas);
        sessionStorage.setItem("mmlTreeData",JSON.stringify({ dataSource: this.moDatas4Tree, id: 'moName', tooltip: this.LOCALE === 'zh'?'zhName':'enName', text: this.LOCALE === 'zh'?'zhName':'enName', child: 'children' }))
      });
    },
    // moTree使用index排序
    compare() {
      return (a, b) => (a.index - b.index);
    },
    // 由于ej2的tree要指定节点是否具有子节点，所以需要将节点转换为Tree结构
    transfer2TreeData(moData, pmoName = ['', 'NA'], rootMoId) {
      return moData.filter(item => pmoName.includes(item.pmoName)).map(item => ({
        ...item,
        expanded: true,
        rootMoId: rootMoId,
        children: this.transfer2TreeData(moData, new Array(item.moName), rootMoId?rootMoId:item.moId),
      }));
    },
    containsKeywords(moData, keywords) {
      let valFlag=false;
        for(let i=0;i<moData.attributes.length;i++){
             if(moData.attributes[i].zhName.toLowerCase().includes(keywords) || moData.attributes[i].enName.toLowerCase().includes(keywords)){
                     valFlag = true;
             }
        }


      return ((moData.zhName && moData.zhName.toLowerCase().includes(keywords))
        || (moData.moName && moData.moName.toLowerCase().includes(keywords))
        || (moData.enName && moData.enName.toLowerCase().includes(keywords))) || valFlag;
    }
  },
  beforeDestroy() {
    bus.$off('loadMoTree');
  }
};
</script>
